import React from 'react';
import PropTypes from 'prop-types';
import CheckedIcon from '../../../icons/CheckedIcon';
import { Typography, withStyles } from 'material-ui';
import SelectedMealListItemStyles from './SelectedMealListItemStyles';

const CheckedMealItem = ({ passengerId, mealId, label, className, classes }) => (
  <Typography
    key={`passenger-${passengerId}-selected-meal-${mealId}`}
    id={`passenger-${passengerId}-selected-meal-${mealId}`}
    type='title'
    color='secondary'
    variant='button'
    className={`${classes.meal} ${className}`}
  >
    <span className={`${classes.span} ${classes.darkGrey}`}>
      {label}
      <CheckedIcon className={classes.ml5} color='rgba(0, 0, 0, 0.54)' />
    </span>
  </Typography>
);

CheckedMealItem.propTypes = {
  mealId: PropTypes.string,
  passengerId: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object,
};

export default withStyles(SelectedMealListItemStyles)(CheckedMealItem);



// WEBPACK FOOTER //
// ./src/components/meals/selectedMealListItem/CheckedMealItem.js